module.exports = __webpack_public_path__ + "static/media/circle-dollar-red.95b6d192.png";